import React from 'react';
import { Field } from 'redux-form'
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import MenuItem from 'material-ui/MenuItem';

import FormAutoComplete2 from './FormAutoComplete2'
import FormSelect from './FormSelect'
import FormText from './FormText'

import * as colors from 'material-ui/styles/colors';

import * as commons from '../commons';

class FormOrderAmmounts extends  React.Component {

  render() {

    const {
      fields,
      status,
      auth
    } = this.props

    return (

      <div>

        {fields.map((name, index) => {
          return (
            <div className="row" key={index}>
              <div className="col-4">
                <Field name={`${name}.orderAmmountBudget`} component={FormText} label="受注金額(予)" style={{ width: '100%' }} format={commons.dispMoney} normalize={commons.dispMoney} disabled={status === 3} />
              </div>
              <div className="col-4">
                <Field name={`${name}.orderAmmount`} component={FormText} label="受注金額(実)" style={{ width: '100%' }} format={commons.dispMoney} normalize={commons.dispMoney} disabled={status === 3 || auth.user.permission != 2} />
              </div>
              <div className="col-4">
                <Field name={`${name}.estimateCode`} component={FormText} label="見積り番号" style={{ width: '100%' }} disabled={status === 3} />
              </div>
            </div>
          )
        })}

        <div className="row">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
            <FloatingActionButton zDepth={0} mini={true} backgroundColor={colors.grey400} disabled={status === 3}
              onClick={() => {
                fields.push({})
              }}>
              <ContentAdd />
            </FloatingActionButton>
          </div>
        </div>

      </div>

    )

  }

}

export default FormOrderAmmounts


// WEBPACK FOOTER //
// ./src/components/FormOrderAmmounts.js